/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as EmbedExternal from "../embed/external.defs.js";
import * as LabelDefs from "../../../com/atproto/label/defs.defs.js";
import * as GraphDefs from "../graph/defs.defs.js";
import * as NotificationDefs from "../notification/defs.defs.js";
import * as RepoStrongRef from "../../../com/atproto/repo/strongRef.defs.js";
import * as FeedThreadgate from "../feed/threadgate.defs.js";
import * as FeedPostgate from "../feed/postgate.defs.js";

const $nsid = "app.bsky.actor.defs";

export { $nsid };

/** A new user experiences (NUX) storage object */
type Nux = { $type?: "app.bsky.actor.defs#nux";"id":string;

  /**
   * Arbitrary data for the NUX. The structure is defined by the NUX itself. Limited to 300 characters.
   */
  "data"?:string;"completed":boolean;

  /**
   * The date and time at which the NUX will expire and should be considered completed.
   */
  "expiresAt"?:l.DatetimeString };

export type { Nux };

/** A new user experiences (NUX) storage object */
const nux = /*#__PURE__*/ l.typedObject<Nux>($nsid, "nux", /*#__PURE__*/ l.object({"id":/*#__PURE__*/ l.string({"maxLength":100}),"data":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"maxLength":3000,"maxGraphemes":300})),"completed":/*#__PURE__*/ l.withDefault(/*#__PURE__*/ l.boolean(), false),"expiresAt":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"datetime"}))}));

export { nux };

/** A word that the account owner has muted. */
type MutedWord = { $type?: "app.bsky.actor.defs#mutedWord";"id"?:string;

  /**
   * The muted word itself.
   */
  "value":string;

  /**
   * The intended targets of the muted word.
   */
  "targets":(MutedWordTarget)[];

  /**
   * The date and time at which the muted word will expire and no longer be applied.
   */
  "expiresAt"?:l.DatetimeString;

  /**
   * Groups of users to apply the muted word to. If undefined, applies to all users.
   */
  "actorTarget"?:"all" | "exclude-following" | l.UnknownString };

export type { MutedWord };

/** A word that the account owner has muted. */
const mutedWord = /*#__PURE__*/ l.typedObject<MutedWord>($nsid, "mutedWord", /*#__PURE__*/ l.object({"id":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),"value":/*#__PURE__*/ l.string({"maxLength":10000,"maxGraphemes":1000}),"targets":/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<MutedWordTarget>((() => mutedWordTarget) as any), ),"expiresAt":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"datetime"})),"actorTarget":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.withDefault(/*#__PURE__*/ l.string<{"knownValues":["all","exclude-following"]}>(), "all"))}));

export { mutedWord };

type SavedFeed = { $type?: "app.bsky.actor.defs#savedFeed";"id":string;"type":"feed" | "list" | "timeline" | l.UnknownString;"value":string;"pinned":boolean };

export type { SavedFeed };

const savedFeed = /*#__PURE__*/ l.typedObject<SavedFeed>($nsid, "savedFeed", /*#__PURE__*/ l.object({"id":/*#__PURE__*/ l.string(),"type":/*#__PURE__*/ l.string<{"knownValues":["feed","list","timeline"]}>(),"value":/*#__PURE__*/ l.string(),"pinned":/*#__PURE__*/ l.boolean()}));

export { savedFeed };

type StatusView = { $type?: "app.bsky.actor.defs#statusView";"cid"?:l.CidString;"uri"?:l.AtUriString;

  /**
   * An optional embed associated with the status.
   */
  "embed"?:l.$Typed<EmbedExternal.View> | l.Unknown$TypedObject;"labels"?:(LabelDefs.Label)[];"record":l.LexMap;

  /**
   * The status for the account.
   */
  "status":"app.bsky.actor.status#live" | l.UnknownString;

  /**
   * True if the status is not expired, false if it is expired. Only present if expiration was set.
   */
  "isActive"?:boolean;

  /**
   * The date when this status will expire. The application might choose to no longer return the status after expiration.
   */
  "expiresAt"?:l.DatetimeString;

  /**
   * True if the user's go-live access has been disabled by a moderator, false otherwise.
   */
  "isDisabled"?:boolean };

export type { StatusView };

const statusView = /*#__PURE__*/ l.typedObject<StatusView>($nsid, "statusView", /*#__PURE__*/ l.object({"cid":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"cid"})),"uri":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"at-uri"})),"embed":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.typedUnion([/*#__PURE__*/ l.typedRef<EmbedExternal.View>((() => EmbedExternal.view) as any)], false)),"labels":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<LabelDefs.Label>((() => LabelDefs.label) as any), )),"record":/*#__PURE__*/ l.lexMap(),"status":/*#__PURE__*/ l.string<{"knownValues":["app.bsky.actor.status#live"]}>(),"isActive":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),"expiresAt":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"datetime"})),"isDisabled":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean())}));

export { statusView };

type Preferences = (l.$Typed<AdultContentPref> | l.$Typed<ContentLabelPref> | l.$Typed<SavedFeedsPref> | l.$Typed<SavedFeedsPrefV2> | l.$Typed<PersonalDetailsPref> | l.$Typed<DeclaredAgePref> | l.$Typed<FeedViewPref> | l.$Typed<ThreadViewPref> | l.$Typed<InterestsPref> | l.$Typed<MutedWordsPref> | l.$Typed<HiddenPostsPref> | l.$Typed<BskyAppStatePref> | l.$Typed<LabelersPref> | l.$Typed<PostInteractionSettingsPref> | l.$Typed<VerificationPrefs> | l.$Typed<LiveEventPreferences> | l.Unknown$TypedObject)[];

export type { Preferences };

const preferences = /*#__PURE__*/ l.array<Preferences[number]>(/*#__PURE__*/ l.typedUnion([/*#__PURE__*/ l.typedRef<AdultContentPref>((() => adultContentPref) as any),/*#__PURE__*/ l.typedRef<ContentLabelPref>((() => contentLabelPref) as any),/*#__PURE__*/ l.typedRef<SavedFeedsPref>((() => savedFeedsPref) as any),/*#__PURE__*/ l.typedRef<SavedFeedsPrefV2>((() => savedFeedsPrefV2) as any),/*#__PURE__*/ l.typedRef<PersonalDetailsPref>((() => personalDetailsPref) as any),/*#__PURE__*/ l.typedRef<DeclaredAgePref>((() => declaredAgePref) as any),/*#__PURE__*/ l.typedRef<FeedViewPref>((() => feedViewPref) as any),/*#__PURE__*/ l.typedRef<ThreadViewPref>((() => threadViewPref) as any),/*#__PURE__*/ l.typedRef<InterestsPref>((() => interestsPref) as any),/*#__PURE__*/ l.typedRef<MutedWordsPref>((() => mutedWordsPref) as any),/*#__PURE__*/ l.typedRef<HiddenPostsPref>((() => hiddenPostsPref) as any),/*#__PURE__*/ l.typedRef<BskyAppStatePref>((() => bskyAppStatePref) as any),/*#__PURE__*/ l.typedRef<LabelersPref>((() => labelersPref) as any),/*#__PURE__*/ l.typedRef<PostInteractionSettingsPref>((() => postInteractionSettingsPref) as any),/*#__PURE__*/ l.typedRef<VerificationPrefs>((() => verificationPrefs) as any),/*#__PURE__*/ l.typedRef<LiveEventPreferences>((() => liveEventPreferences) as any)], false), );

export { preferences };

type ProfileView = { $type?: "app.bsky.actor.defs#profileView";"did":l.DidString;

  /**
   * Debug information for internal development
   */
  "debug"?:l.LexMap;"avatar"?:l.UriString;"handle":l.HandleString;"labels"?:(LabelDefs.Label)[];"status"?:StatusView;"viewer"?:ViewerState;"pronouns"?:string;"createdAt"?:l.DatetimeString;"indexedAt"?:l.DatetimeString;"associated"?:ProfileAssociated;"description"?:string;"displayName"?:string;"verification"?:VerificationState };

export type { ProfileView };

const profileView = /*#__PURE__*/ l.typedObject<ProfileView>($nsid, "profileView", /*#__PURE__*/ l.object({"did":/*#__PURE__*/ l.string({"format":"did"}),"debug":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.lexMap()),"avatar":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"uri"})),"handle":/*#__PURE__*/ l.string({"format":"handle"}),"labels":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<LabelDefs.Label>((() => LabelDefs.label) as any), )),"status":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<StatusView>((() => statusView) as any)),"viewer":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<ViewerState>((() => viewerState) as any)),"pronouns":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),"createdAt":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"datetime"})),"indexedAt":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"datetime"})),"associated":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<ProfileAssociated>((() => profileAssociated) as any)),"description":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"maxLength":2560,"maxGraphemes":256})),"displayName":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"maxLength":640,"maxGraphemes":64})),"verification":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<VerificationState>((() => verificationState) as any))}));

export { profileView };

/** Metadata about the requesting account's relationship with the subject account. Only has meaningful content for authed requests. */
type ViewerState = { $type?: "app.bsky.actor.defs#viewerState";"muted"?:boolean;"blocking"?:l.AtUriString;"blockedBy"?:boolean;"following"?:l.AtUriString;"followedBy"?:l.AtUriString;"mutedByList"?:GraphDefs.ListViewBasic;"blockingByList"?:GraphDefs.ListViewBasic;

  /**
   * This property is present only in selected cases, as an optimization.
   */
  "knownFollowers"?:KnownFollowers;

  /**
   * This property is present only in selected cases, as an optimization.
   */
  "activitySubscription"?:NotificationDefs.ActivitySubscription };

export type { ViewerState };

/** Metadata about the requesting account's relationship with the subject account. Only has meaningful content for authed requests. */
const viewerState = /*#__PURE__*/ l.typedObject<ViewerState>($nsid, "viewerState", /*#__PURE__*/ l.object({"muted":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),"blocking":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"at-uri"})),"blockedBy":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),"following":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"at-uri"})),"followedBy":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"at-uri"})),"mutedByList":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<GraphDefs.ListViewBasic>((() => GraphDefs.listViewBasic) as any)),"blockingByList":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<GraphDefs.ListViewBasic>((() => GraphDefs.listViewBasic) as any)),"knownFollowers":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<KnownFollowers>((() => knownFollowers) as any)),"activitySubscription":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<NotificationDefs.ActivitySubscription>((() => NotificationDefs.activitySubscription) as any))}));

export { viewerState };

type FeedViewPref = { $type?: "app.bsky.actor.defs#feedViewPref";

  /**
   * The URI of the feed, or an identifier which describes the feed.
   */
  "feed":string;

  /**
   * Hide replies in the feed.
   */
  "hideReplies"?:boolean;

  /**
   * Hide reposts in the feed.
   */
  "hideReposts"?:boolean;

  /**
   * Hide quote posts in the feed.
   */
  "hideQuotePosts"?:boolean;

  /**
   * Hide replies in the feed if they do not have this number of likes.
   */
  "hideRepliesByLikeCount"?:number;

  /**
   * Hide replies in the feed if they are not by followed users.
   */
  "hideRepliesByUnfollowed"?:boolean };

export type { FeedViewPref };

const feedViewPref = /*#__PURE__*/ l.typedObject<FeedViewPref>($nsid, "feedViewPref", /*#__PURE__*/ l.object({"feed":/*#__PURE__*/ l.string(),"hideReplies":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),"hideReposts":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),"hideQuotePosts":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),"hideRepliesByLikeCount":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),"hideRepliesByUnfollowed":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.withDefault(/*#__PURE__*/ l.boolean(), true))}));

export { feedViewPref };

type LabelersPref = { $type?: "app.bsky.actor.defs#labelersPref";"labelers":(LabelerPrefItem)[] };

export type { LabelersPref };

const labelersPref = /*#__PURE__*/ l.typedObject<LabelersPref>($nsid, "labelersPref", /*#__PURE__*/ l.object({"labelers":/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<LabelerPrefItem>((() => labelerPrefItem) as any), )}));

export { labelersPref };

type InterestsPref = { $type?: "app.bsky.actor.defs#interestsPref";

  /**
   * A list of tags which describe the account owner's interests gathered during onboarding.
   */
  "tags":(string)[] };

export type { InterestsPref };

const interestsPref = /*#__PURE__*/ l.typedObject<InterestsPref>($nsid, "interestsPref", /*#__PURE__*/ l.object({"tags":/*#__PURE__*/ l.array(/*#__PURE__*/ l.string({"maxLength":640,"maxGraphemes":64}), {"maxLength":100})}));

export { interestsPref };

/** The subject's followers whom you also follow */
type KnownFollowers = { $type?: "app.bsky.actor.defs#knownFollowers";"count":number;"followers":(ProfileViewBasic)[] };

export type { KnownFollowers };

/** The subject's followers whom you also follow */
const knownFollowers = /*#__PURE__*/ l.typedObject<KnownFollowers>($nsid, "knownFollowers", /*#__PURE__*/ l.object({"count":/*#__PURE__*/ l.integer(),"followers":/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<ProfileViewBasic>((() => profileViewBasic) as any), {"maxLength":5,"minLength":0})}));

export { knownFollowers };

type MutedWordsPref = { $type?: "app.bsky.actor.defs#mutedWordsPref";

  /**
   * A list of words the account owner has muted.
   */
  "items":(MutedWord)[] };

export type { MutedWordsPref };

const mutedWordsPref = /*#__PURE__*/ l.typedObject<MutedWordsPref>($nsid, "mutedWordsPref", /*#__PURE__*/ l.object({"items":/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<MutedWord>((() => mutedWord) as any), )}));

export { mutedWordsPref };

type SavedFeedsPref = { $type?: "app.bsky.actor.defs#savedFeedsPref";"saved":(l.AtUriString)[];"pinned":(l.AtUriString)[];"timelineIndex"?:number };

export type { SavedFeedsPref };

const savedFeedsPref = /*#__PURE__*/ l.typedObject<SavedFeedsPref>($nsid, "savedFeedsPref", /*#__PURE__*/ l.object({"saved":/*#__PURE__*/ l.array(/*#__PURE__*/ l.string({"format":"at-uri"}), ),"pinned":/*#__PURE__*/ l.array(/*#__PURE__*/ l.string({"format":"at-uri"}), ),"timelineIndex":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer())}));

export { savedFeedsPref };

type ThreadViewPref = { $type?: "app.bsky.actor.defs#threadViewPref";

  /**
   * Sorting mode for threads.
   */
  "sort"?:"oldest" | "newest" | "most-likes" | "random" | "hotness" | l.UnknownString };

export type { ThreadViewPref };

const threadViewPref = /*#__PURE__*/ l.typedObject<ThreadViewPref>($nsid, "threadViewPref", /*#__PURE__*/ l.object({"sort":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string<{"knownValues":["oldest","newest","most-likes","random","hotness"]}>())}));

export { threadViewPref };

/** Read-only preference containing value(s) inferred from the user's declared birthdate. Absence of this preference object in the response indicates that the user has not made a declaration. */
type DeclaredAgePref = { $type?: "app.bsky.actor.defs#declaredAgePref";

  /**
   * Indicates if the user has declared that they are over 13 years of age.
   */
  "isOverAge13"?:boolean;

  /**
   * Indicates if the user has declared that they are over 16 years of age.
   */
  "isOverAge16"?:boolean;

  /**
   * Indicates if the user has declared that they are over 18 years of age.
   */
  "isOverAge18"?:boolean };

export type { DeclaredAgePref };

/** Read-only preference containing value(s) inferred from the user's declared birthdate. Absence of this preference object in the response indicates that the user has not made a declaration. */
const declaredAgePref = /*#__PURE__*/ l.typedObject<DeclaredAgePref>($nsid, "declaredAgePref", /*#__PURE__*/ l.object({"isOverAge13":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),"isOverAge16":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),"isOverAge18":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean())}));

export { declaredAgePref };

type HiddenPostsPref = { $type?: "app.bsky.actor.defs#hiddenPostsPref";

  /**
   * A list of URIs of posts the account owner has hidden.
   */
  "items":(l.AtUriString)[] };

export type { HiddenPostsPref };

const hiddenPostsPref = /*#__PURE__*/ l.typedObject<HiddenPostsPref>($nsid, "hiddenPostsPref", /*#__PURE__*/ l.object({"items":/*#__PURE__*/ l.array(/*#__PURE__*/ l.string({"format":"at-uri"}), )}));

export { hiddenPostsPref };

type LabelerPrefItem = { $type?: "app.bsky.actor.defs#labelerPrefItem";"did":l.DidString };

export type { LabelerPrefItem };

const labelerPrefItem = /*#__PURE__*/ l.typedObject<LabelerPrefItem>($nsid, "labelerPrefItem", /*#__PURE__*/ l.object({"did":/*#__PURE__*/ l.string({"format":"did"})}));

export { labelerPrefItem };

type MutedWordTarget = "content" | "tag" | l.UnknownString;

export type { MutedWordTarget };

const mutedWordTarget = /*#__PURE__*/ l.string<{"maxLength":640,"knownValues":["content","tag"],"maxGraphemes":64}>({"maxLength":640,"maxGraphemes":64});

export { mutedWordTarget };

type AdultContentPref = { $type?: "app.bsky.actor.defs#adultContentPref";"enabled":boolean };

export type { AdultContentPref };

const adultContentPref = /*#__PURE__*/ l.typedObject<AdultContentPref>($nsid, "adultContentPref", /*#__PURE__*/ l.object({"enabled":/*#__PURE__*/ l.withDefault(/*#__PURE__*/ l.boolean(), false)}));

export { adultContentPref };

/** A grab bag of state that's specific to the bsky.app program. Third-party apps shouldn't use this. */
type BskyAppStatePref = { $type?: "app.bsky.actor.defs#bskyAppStatePref";

  /**
   * Storage for NUXs the user has encountered.
   */
  "nuxs"?:(Nux)[];

  /**
   * Indicates if the user is participating in the beta features program.
   */
  "isBetaUser"?:boolean;

  /**
   * An array of tokens which identify nudges (modals, popups, tours, highlight dots) that should be shown to the user.
   */
  "queuedNudges"?:(string)[];"activeProgressGuide"?:BskyAppProgressGuide };

export type { BskyAppStatePref };

/** A grab bag of state that's specific to the bsky.app program. Third-party apps shouldn't use this. */
const bskyAppStatePref = /*#__PURE__*/ l.typedObject<BskyAppStatePref>($nsid, "bskyAppStatePref", /*#__PURE__*/ l.object({"nuxs":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<Nux>((() => nux) as any), {"maxLength":100})),"isBetaUser":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),"queuedNudges":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.array(/*#__PURE__*/ l.string({"maxLength":100}), {"maxLength":1000})),"activeProgressGuide":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<BskyAppProgressGuide>((() => bskyAppProgressGuide) as any))}));

export { bskyAppStatePref };

type ContentLabelPref = { $type?: "app.bsky.actor.defs#contentLabelPref";"label":string;

  /**
   * Which labeler does this preference apply to? If undefined, applies globally.
   */
  "labelerDid"?:l.DidString;"visibility":"ignore" | "show" | "warn" | "hide" | l.UnknownString };

export type { ContentLabelPref };

const contentLabelPref = /*#__PURE__*/ l.typedObject<ContentLabelPref>($nsid, "contentLabelPref", /*#__PURE__*/ l.object({"label":/*#__PURE__*/ l.string(),"labelerDid":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"did"})),"visibility":/*#__PURE__*/ l.string<{"knownValues":["ignore","show","warn","hide"]}>()}));

export { contentLabelPref };

type ProfileViewBasic = { $type?: "app.bsky.actor.defs#profileViewBasic";"did":l.DidString;

  /**
   * Debug information for internal development
   */
  "debug"?:l.LexMap;"avatar"?:l.UriString;"handle":l.HandleString;"labels"?:(LabelDefs.Label)[];"status"?:StatusView;"viewer"?:ViewerState;"pronouns"?:string;"createdAt"?:l.DatetimeString;"associated"?:ProfileAssociated;"displayName"?:string;"verification"?:VerificationState };

export type { ProfileViewBasic };

const profileViewBasic = /*#__PURE__*/ l.typedObject<ProfileViewBasic>($nsid, "profileViewBasic", /*#__PURE__*/ l.object({"did":/*#__PURE__*/ l.string({"format":"did"}),"debug":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.lexMap()),"avatar":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"uri"})),"handle":/*#__PURE__*/ l.string({"format":"handle"}),"labels":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<LabelDefs.Label>((() => LabelDefs.label) as any), )),"status":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<StatusView>((() => statusView) as any)),"viewer":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<ViewerState>((() => viewerState) as any)),"pronouns":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),"createdAt":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"datetime"})),"associated":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<ProfileAssociated>((() => profileAssociated) as any)),"displayName":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"maxLength":640,"maxGraphemes":64})),"verification":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<VerificationState>((() => verificationState) as any))}));

export { profileViewBasic };

type SavedFeedsPrefV2 = { $type?: "app.bsky.actor.defs#savedFeedsPrefV2";"items":(SavedFeed)[] };

export type { SavedFeedsPrefV2 };

const savedFeedsPrefV2 = /*#__PURE__*/ l.typedObject<SavedFeedsPrefV2>($nsid, "savedFeedsPrefV2", /*#__PURE__*/ l.object({"items":/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<SavedFeed>((() => savedFeed) as any), )}));

export { savedFeedsPrefV2 };

/** An individual verification for an associated subject. */
type VerificationView = { $type?: "app.bsky.actor.defs#verificationView";

  /**
   * The AT-URI of the verification record.
   */
  "uri":l.AtUriString;

  /**
   * The user who issued this verification.
   */
  "issuer":l.DidString;

  /**
   * True if the verification passes validation, otherwise false.
   */
  "isValid":boolean;

  /**
   * Timestamp when the verification was created.
   */
  "createdAt":l.DatetimeString;

  /**
   * The handle of the issuer.
   */
  "issuerHandle"?:l.HandleString;

  /**
   * The display name of the issuer.
   */
  "issuerDisplayName"?:string };

export type { VerificationView };

/** An individual verification for an associated subject. */
const verificationView = /*#__PURE__*/ l.typedObject<VerificationView>($nsid, "verificationView", /*#__PURE__*/ l.object({"uri":/*#__PURE__*/ l.string({"format":"at-uri"}),"issuer":/*#__PURE__*/ l.string({"format":"did"}),"isValid":/*#__PURE__*/ l.boolean(),"createdAt":/*#__PURE__*/ l.string({"format":"datetime"}),"issuerHandle":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"handle"})),"issuerDisplayName":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string())}));

export { verificationView };

type ProfileAssociated = { $type?: "app.bsky.actor.defs#profileAssociated";"chat"?:ProfileAssociatedChat;"germ"?:ProfileAssociatedGerm;"lists"?:number;"labeler"?:boolean;"feedgens"?:number;"starterPacks"?:number;"activitySubscription"?:ProfileAssociatedActivitySubscription };

export type { ProfileAssociated };

const profileAssociated = /*#__PURE__*/ l.typedObject<ProfileAssociated>($nsid, "profileAssociated", /*#__PURE__*/ l.object({"chat":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<ProfileAssociatedChat>((() => profileAssociatedChat) as any)),"germ":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<ProfileAssociatedGerm>((() => profileAssociatedGerm) as any)),"lists":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),"labeler":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),"feedgens":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),"starterPacks":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),"activitySubscription":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<ProfileAssociatedActivitySubscription>((() => profileAssociatedActivitySubscription) as any))}));

export { profileAssociated };

/** Preferences for how verified accounts appear in the app. */
type VerificationPrefs = { $type?: "app.bsky.actor.defs#verificationPrefs";

  /**
   * Hide the blue check badges for verified accounts and trusted verifiers.
   */
  "hideBadges"?:boolean };

export type { VerificationPrefs };

/** Preferences for how verified accounts appear in the app. */
const verificationPrefs = /*#__PURE__*/ l.typedObject<VerificationPrefs>($nsid, "verificationPrefs", /*#__PURE__*/ l.object({"hideBadges":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.withDefault(/*#__PURE__*/ l.boolean(), false))}));

export { verificationPrefs };

/** Represents the verification information about the user this object is attached to. */
type VerificationState = { $type?: "app.bsky.actor.defs#verificationState";

  /**
   * All verifications issued by trusted verifiers on behalf of this user. Verifications by untrusted verifiers are not included.
   */
  "verifications":(VerificationView)[];

  /**
   * The user's status as a verified account.
   */
  "verifiedStatus":"valid" | "invalid" | "none" | l.UnknownString;

  /**
   * The user's status as a trusted verifier.
   */
  "trustedVerifierStatus":"valid" | "invalid" | "none" | l.UnknownString };

export type { VerificationState };

/** Represents the verification information about the user this object is attached to. */
const verificationState = /*#__PURE__*/ l.typedObject<VerificationState>($nsid, "verificationState", /*#__PURE__*/ l.object({"verifications":/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<VerificationView>((() => verificationView) as any), ),"verifiedStatus":/*#__PURE__*/ l.string<{"knownValues":["valid","invalid","none"]}>(),"trustedVerifierStatus":/*#__PURE__*/ l.string<{"knownValues":["valid","invalid","none"]}>()}));

export { verificationState };

type PersonalDetailsPref = { $type?: "app.bsky.actor.defs#personalDetailsPref";

  /**
   * The birth date of account owner.
   */
  "birthDate"?:l.DatetimeString };

export type { PersonalDetailsPref };

const personalDetailsPref = /*#__PURE__*/ l.typedObject<PersonalDetailsPref>($nsid, "personalDetailsPref", /*#__PURE__*/ l.object({"birthDate":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"datetime"}))}));

export { personalDetailsPref };

type ProfileViewDetailed = { $type?: "app.bsky.actor.defs#profileViewDetailed";"did":l.DidString;

  /**
   * Debug information for internal development
   */
  "debug"?:l.LexMap;"avatar"?:l.UriString;"banner"?:l.UriString;"handle":l.HandleString;"labels"?:(LabelDefs.Label)[];"status"?:StatusView;"viewer"?:ViewerState;"website"?:l.UriString;"pronouns"?:string;"createdAt"?:l.DatetimeString;"indexedAt"?:l.DatetimeString;"associated"?:ProfileAssociated;"pinnedPost"?:RepoStrongRef.Main;"postsCount"?:number;"description"?:string;"displayName"?:string;"followsCount"?:number;"verification"?:VerificationState;"followersCount"?:number;"joinedViaStarterPack"?:GraphDefs.StarterPackViewBasic };

export type { ProfileViewDetailed };

const profileViewDetailed = /*#__PURE__*/ l.typedObject<ProfileViewDetailed>($nsid, "profileViewDetailed", /*#__PURE__*/ l.object({"did":/*#__PURE__*/ l.string({"format":"did"}),"debug":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.lexMap()),"avatar":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"uri"})),"banner":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"uri"})),"handle":/*#__PURE__*/ l.string({"format":"handle"}),"labels":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<LabelDefs.Label>((() => LabelDefs.label) as any), )),"status":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<StatusView>((() => statusView) as any)),"viewer":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<ViewerState>((() => viewerState) as any)),"website":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"uri"})),"pronouns":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),"createdAt":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"datetime"})),"indexedAt":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"datetime"})),"associated":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<ProfileAssociated>((() => profileAssociated) as any)),"pinnedPost":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<RepoStrongRef.Main>((() => RepoStrongRef.main) as any)),"postsCount":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),"description":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"maxLength":2560,"maxGraphemes":256})),"displayName":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"maxLength":640,"maxGraphemes":64})),"followsCount":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),"verification":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<VerificationState>((() => verificationState) as any)),"followersCount":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),"joinedViaStarterPack":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<GraphDefs.StarterPackViewBasic>((() => GraphDefs.starterPackViewBasic) as any))}));

export { profileViewDetailed };

/** If set, an active progress guide. Once completed, can be set to undefined. Should have unspecced fields tracking progress. */
type BskyAppProgressGuide = { $type?: "app.bsky.actor.defs#bskyAppProgressGuide";"guide":string };

export type { BskyAppProgressGuide };

/** If set, an active progress guide. Once completed, can be set to undefined. Should have unspecced fields tracking progress. */
const bskyAppProgressGuide = /*#__PURE__*/ l.typedObject<BskyAppProgressGuide>($nsid, "bskyAppProgressGuide", /*#__PURE__*/ l.object({"guide":/*#__PURE__*/ l.string({"maxLength":100})}));

export { bskyAppProgressGuide };

/** Preferences for live events. */
type LiveEventPreferences = { $type?: "app.bsky.actor.defs#liveEventPreferences";

  /**
   * Whether to hide all feeds from live events.
   */
  "hideAllFeeds"?:boolean;

  /**
   * A list of feed IDs that the user has hidden from live events.
   */
  "hiddenFeedIds"?:(string)[] };

export type { LiveEventPreferences };

/** Preferences for live events. */
const liveEventPreferences = /*#__PURE__*/ l.typedObject<LiveEventPreferences>($nsid, "liveEventPreferences", /*#__PURE__*/ l.object({"hideAllFeeds":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.withDefault(/*#__PURE__*/ l.boolean(), false)),"hiddenFeedIds":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.array(/*#__PURE__*/ l.string(), ))}));

export { liveEventPreferences };

type ProfileAssociatedChat = { $type?: "app.bsky.actor.defs#profileAssociatedChat";"allowIncoming":"all" | "none" | "following" | l.UnknownString;"allowGroupInvites"?:"all" | "none" | "following" | l.UnknownString };

export type { ProfileAssociatedChat };

const profileAssociatedChat = /*#__PURE__*/ l.typedObject<ProfileAssociatedChat>($nsid, "profileAssociatedChat", /*#__PURE__*/ l.object({"allowIncoming":/*#__PURE__*/ l.string<{"knownValues":["all","none","following"]}>(),"allowGroupInvites":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string<{"knownValues":["all","none","following"]}>())}));

export { profileAssociatedChat };

type ProfileAssociatedGerm = { $type?: "app.bsky.actor.defs#profileAssociatedGerm";"messageMeUrl":l.UriString;"showButtonTo":"usersIFollow" | "everyone" | l.UnknownString };

export type { ProfileAssociatedGerm };

const profileAssociatedGerm = /*#__PURE__*/ l.typedObject<ProfileAssociatedGerm>($nsid, "profileAssociatedGerm", /*#__PURE__*/ l.object({"messageMeUrl":/*#__PURE__*/ l.string({"format":"uri"}),"showButtonTo":/*#__PURE__*/ l.string<{"knownValues":["usersIFollow","everyone"]}>()}));

export { profileAssociatedGerm };

/** Default post interaction settings for the account. These values should be applied as default values when creating new posts. These refs should mirror the threadgate and postgate records exactly. */
type PostInteractionSettingsPref = { $type?: "app.bsky.actor.defs#postInteractionSettingsPref";

  /**
   * Matches threadgate record. List of rules defining who can reply to this users posts. If value is an empty array, no one can reply. If value is undefined, anyone can reply.
   */
  "threadgateAllowRules"?:(l.$Typed<FeedThreadgate.MentionRule> | l.$Typed<FeedThreadgate.FollowerRule> | l.$Typed<FeedThreadgate.FollowingRule> | l.$Typed<FeedThreadgate.ListRule> | l.Unknown$TypedObject)[];

  /**
   * Matches postgate record. List of rules defining who can embed this users posts. If value is an empty array or is undefined, no particular rules apply and anyone can embed.
   */
  "postgateEmbeddingRules"?:(l.$Typed<FeedPostgate.DisableRule> | l.Unknown$TypedObject)[] };

export type { PostInteractionSettingsPref };

/** Default post interaction settings for the account. These values should be applied as default values when creating new posts. These refs should mirror the threadgate and postgate records exactly. */
const postInteractionSettingsPref = /*#__PURE__*/ l.typedObject<PostInteractionSettingsPref>($nsid, "postInteractionSettingsPref", /*#__PURE__*/ l.object({"threadgateAllowRules":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.array(/*#__PURE__*/ l.typedUnion([/*#__PURE__*/ l.typedRef<FeedThreadgate.MentionRule>((() => FeedThreadgate.mentionRule) as any),/*#__PURE__*/ l.typedRef<FeedThreadgate.FollowerRule>((() => FeedThreadgate.followerRule) as any),/*#__PURE__*/ l.typedRef<FeedThreadgate.FollowingRule>((() => FeedThreadgate.followingRule) as any),/*#__PURE__*/ l.typedRef<FeedThreadgate.ListRule>((() => FeedThreadgate.listRule) as any)], false), {"maxLength":5})),"postgateEmbeddingRules":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.array(/*#__PURE__*/ l.typedUnion([/*#__PURE__*/ l.typedRef<FeedPostgate.DisableRule>((() => FeedPostgate.disableRule) as any)], false), {"maxLength":5}))}));

export { postInteractionSettingsPref };

type ProfileAssociatedActivitySubscription = { $type?: "app.bsky.actor.defs#profileAssociatedActivitySubscription";"allowSubscriptions":"followers" | "mutuals" | "none" | l.UnknownString };

export type { ProfileAssociatedActivitySubscription };

const profileAssociatedActivitySubscription = /*#__PURE__*/ l.typedObject<ProfileAssociatedActivitySubscription>($nsid, "profileAssociatedActivitySubscription", /*#__PURE__*/ l.object({"allowSubscriptions":/*#__PURE__*/ l.string<{"knownValues":["followers","mutuals","none"]}>()}));

export { profileAssociatedActivitySubscription };
